__turbopack_context__.v({
  "containerGrid": "ItinerariesGrid-module__oc3Mfq__containerGrid",
  "footerWrapper": "ItinerariesGrid-module__oc3Mfq__footerWrapper",
  "gridSection": "ItinerariesGrid-module__oc3Mfq__gridSection",
  "itinerariesFooter": "ItinerariesGrid-module__oc3Mfq__itinerariesFooter",
  "loaderWrapper": "ItinerariesGrid-module__oc3Mfq__loaderWrapper",
  "paginationWrapper": "ItinerariesGrid-module__oc3Mfq__paginationWrapper",
  "subtitle": "ItinerariesGrid-module__oc3Mfq__subtitle",
});
